<template>
  <div class="ts-app-shell_fh">
  <RegistrationQuestionnaire :currentPage="currentPageStep">
    <div class="check-list-form">
      <div class="content-type">
        <span>Registration Information</span>
      </div>
      <el-form
        :model="registrationAnswer"
        @submit.native.prevent="updateRegistrationAnswers"
      >
        <p>Please provide registration information in order for us to best serve you</p>
        <p class="heavy-text">Employment Information</p>
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Current Employment Status:</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EmploymentInfo.EmploymentStatus'
                  )
                "
              >
                <el-select v-model="registrationAnswer.employmentInfo.employmentStatus" placeholder="Select">
                  <el-option
                    v-for="item in employmentStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Type of business worked in:</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EmploymentInfo.TypeOfBusinessWorkedIn'
                  )
                "
              >
                <el-select v-model="registrationAnswer.employmentInfo.typeOfBusinessWorkedIn" placeholder="Select">
                  <el-option
                    v-for="item in businessTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Are you currently looking for work?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EmploymentInfo.CurrentlyLookingForWork'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.employmentInfo.currentlyLookingForWork"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Do you have any related licenses or certifications?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EmploymentInfo.AnyRelatedLicenses'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.employmentInfo.anyRelatedLicenses"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Have you recently relocated due to a recent major disaster (e.g. hurricane)?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EmploymentInfo.RecentlyRelocated'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.employmentInfo.recentlyRelocated"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Within the last 12 months, have you received a notice of termination or layoff from your job or received documentation
                that you are separating from military service?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EmploymentInfo.ReceivedNoticeOfTermination'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.employmentInfo.receivedNoticeOfTermination"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes, I have recently received a notice of termination, layoff or military service</el-radio>
                  <el-radio :label="1" size="large">No, I have not recently received a notice of termination</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Date of Layoff, Termination or Military Separation (If applicable):</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'EmploymentInfo.LayoffDate'
                  )
                "
              >
                <el-date-picker
                  v-model="registrationAnswer.employmentInfo.layoffDate"
                  type="date"
                  placeholder="MM/DD/YYY"
                  value-format="MM/dd/yyyy"
                  format="MM/dd/yyyy"
                  size="small"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <p class="heavy-text">Farmworker Information</p>
        <p>The following questions do not pertain to work performed on a family farm, ranch, beekeeping, food processing or food
          manufacturing operation owned by yourself or close relatives.
        </p>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Have you worked as a farmworker in the last 12 months?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'FarmworkerInfo.WorkedAsFarmworker'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.farmworkerInfo.workedAsFarmworker"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Have you been employed the past 12 months in Farmwork of a seasonal or temporary nature?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'FarmworkerInfo.EmployedAsSeasonalTemporary'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.farmworkerInfo.employedAsSeasonalTemporary"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Have you travelled to the site and are not reasonably able to return to your permanent residence within the same day?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'FarmworkerInfo.TravelledOnSite'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.farmworkerInfo.travelledOnSite"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Are you a full-time student?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'FarmworkerInfo.FullTimeStudent'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.farmworkerInfo.fullTimeStudent"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Are you travelling with your family?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'FarmworkerInfo.TravellingWithFamily'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.farmworkerInfo.travellingWithFamily"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <div class="mb-2 flex items-center text-sm">
              <label role="text">
                Are you travelling with an organized group?
              </label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'FarmworkerInfo.TravellingInOrganizedGroup'
                  )
                "
              >
                <el-radio-group
                  v-model="registrationAnswer.farmworkerInfo.travellingInOrganizedGroup"
                  class="ml-4"
                >
                  <el-radio :label="0" size="large">Yes</el-radio>
                  <el-radio :label="1" size="large">No</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </el-row>
        </div>
        <div class="content-item">
          <el-row>
            <el-col :xl="24" :lg="24" :md="24" :sm="24">
              <label role="text">Type of National Farm Worker (If applicable):</label>
              <el-form-item
                :error="
                  retrieveFieldError(
                    modelState,
                    'FarmworkerInfo.FarmWorkerType'
                  )
                "
              >
                <el-select v-model="registrationAnswer.farmworkerInfo.farmWorkerType" placeholder="Select">
                  <el-option
                    v-for="item in farmworkerOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="content-item action-section">
          <el-row>
            <el-col span="8">
              <el-button
                class="ts-btn ts-btn-outline wioa-btn-outline"
                @click="backToDashboard"
              >
                Previous
              </el-button>
            </el-col>
            <el-col span="8">
              <el-button
                class="ts-btn ts-btn-secondary"
                @click="updateRegistrationAnswers"
              >
                Next
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
  </RegistrationQuestionnaire>
  <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import RegistrationQuestionnaire from "../../component/RegistrationQuestionnaire.vue";
import TSLoading from "../../../../components/TSLoading.vue";
import dateUtils from "@/utils/date.utils";

export default {
  components: { 
    RegistrationQuestionnaire, 
    TSLoading,
  },
  data(){
    return{
      modelState: {},
      isLoading: false,
      registrationAnswer: {
        priorityOfService: {},
        militaryService: {},
        veteranInfo: {},
        transitioningServiceMembers: {},
        militaryMemberSpouse: {},
        disability: {},
        householdInfo: {},
        publicAssistance: {},
        demographicInfo: {},
        ethnicOrigin: {},
        race: {
          raceSelection: []
        },
        language: {},
        educationInfo: {},
        employmentInfo: {},
        farmworkerInfo: {},
      },
      employmentInfoEmpty: {
        employmentStatus: null,
        typeOfBusinessWorkedIn: null,
        currentlyLookingForWork: null,
        anyRelatedLicenses: null,
        recentlyRelocated: null,
        receivedNoticeOfTermination: null,
        layoffDate: null,
      },
      farmworkerInfoEmpty: {
        workedAsFarmworker: null,
        employedAsSeasonalTemporary: null,
        travelledOnSite: null,
        fullTimeStudent: null,
        travellingWithFamily: null,
        travellingInOrganizedGroup: null,
        farmWorkerType: null,
      },
      jobSeekerId: null,
      employmentStatusOptions: [{
          value: 'Working Full Time',
          label: 'Working Full Time'
        }, {
          value: 'Working Part Time',
          label: 'Working Part Time'
        }, {
          value: 'Self-Employed',
          label: 'Self-Employed'
        }, {
          value: 'Not Working',
          label: 'Not Working'
        }, {
          value: 'Never Worked',
          label: 'Never Worked'
        }, {
          value: 'Other',
          label: 'Other'
        }],
      businessTypeOptions: [{
          value: 'Private Business',
          label: 'Private Business'
        }, {
          value: 'Local Government',
          label: 'Local Government'
        }, {
          value: 'Federal Government',
          label: 'Federal Government'
        }, {
          value: 'Never Worked',
          label: 'Never Worked'
        }, {
          value: 'Other',
          label: 'Other'
        }],
      farmworkerOptions: [{
          value: 'Migrant Farmworker',
          label: 'Migrant Farmworker'
        }, {
          value: 'Seasonal Farmworker',
          label: 'Seasonal Farmworker'
        }, {
          value: 'H-2A VISA Farmworker',
          label: 'H-2A VISA Farmworker'
        }, {
          value: 'Undocumented Farmworker',
          label: 'Undocumented Farmworker'
        }, {
          value: 'Local Hired Farmworker',
          label: 'Local Hired Farmworker'
        }, {
          value: 'Day Laborers',
          label: 'Day Laborers'
        }],
    }
  },
  computed: {
    currentPageStep() {
      return this.$route.meta.currentPage;
    },
  },
  created() {
    window.scrollTo(0,0);
    this.isLoading = true;
    this.jobSeekerId = this.$store.state.account.applicant_user_info.jobSeekerId;
    this.$store
      .dispatch("jobseeker/getRegistrationAnswerByJobSeekerId", this.jobSeekerId)
      .then((res) => {
        if (res === null || res === undefined || res.priorityOfService === null) {
          this.$router.push({ name: "RegistrationQuestionnaireOne" });
        } else {
          this.registrationAnswer = res;

          this.registrationAnswer.employmentInfo = this.registrationAnswer.employmentInfo === null 
            ? this.employmentInfoEmpty 
            : this.registrationAnswer.employmentInfo;

          this.registrationAnswer.farmworkerInfo = this.registrationAnswer.farmworkerInfo === null 
            ? this.farmworkerInfoEmpty 
            : this.registrationAnswer.farmworkerInfo;
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    backToDashboard() {
      this.$router.push({ name: "RegistrationQuestionnaireFive" });
    },
    updateRegistrationAnswers() {
      this.isLoading = true;
      this.registrationAnswer.validatePageType = 6;

      //EVA
      if(this.registrationAnswer.employmentInfo.layoffDate != null)
        this.registrationAnswer.employmentInfo.layoffDate = dateUtils.formatDateToISOString(this.registrationAnswer.employmentInfo.layoffDate);

      this.$store
        .dispatch("jobseeker/updateRegistrationAnswer", this.registrationAnswer)
        .then(res => {
          if (res) {
            this.$router.push({ name: "RegistrationQuestionnaireSeven" });
          }
        })
        .catch(res => {
          this.modelState = res;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
